var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"front_wrap"},[_c('BreadCrumb',{attrs:{"crumb":"网站统计"}}),_vm._v(" "),_c('CountPannel'),_vm._v(" "),_c('CurveGraph'),_vm._v(" "),_c('PieGraph'),_vm._v(" "),_c('PieGraphOne')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c976db98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/WebsiteStatistics.vue
// module id = null
// module chunks = 